import type { OPERATION_TYPE } from './constants';
import { EXTRA_PARAMS_LABELS } from './constants';

type ExtraParam = {
  title: string;
  value: string | number | boolean | null;
};

// Recursively visits the object and collects filled extra params
export function parseExtraParams(
  object: unknown,
  operationType: OPERATION_TYPE,
): ExtraParam[] {
  const results: ExtraParam[] = [];
  const labels = EXTRA_PARAMS_LABELS[operationType];

  const isPlainObject = (v: unknown): v is Record<string, unknown> =>
    typeof v === 'object' && v !== null && !Array.isArray(v);

  const isPrimitive = (v: unknown): v is string | number | boolean | Date =>
    typeof v === 'string' ||
    typeof v === 'number' ||
    typeof v === 'boolean' ||
    v instanceof Date;

  const isFilled = (v: unknown): boolean =>
    v !== null && v !== undefined && (typeof v !== 'string' || v.trim() !== '');

  const visit = (val: unknown, key?: string) => {
    const title = key ? labels[key] : undefined;
    if (title && isPrimitive(val) && isFilled(val)) {
      results.push({
        title,
        value: val instanceof Date ? val.toISOString() : val,
      });
      return;
    }

    if (Array.isArray(val)) {
      val.forEach((item) => visit(item));
      return;
    }

    if (isPlainObject(val)) {
      Object.entries(val).forEach(([k, v]) => visit(v, k));
    }
  };

  visit(object);
  return results;
}
